<template>
    <svg
        id="Camada_2"
        data-name="Camada 2"
        viewBox="0 0 380.84 382.96"
        xmlns="http://www.w3.org/2000/svg">
        <g
            id="Layer_1"
            data-name="Layer 1">
            <g>
                <path
                    class="cls-8"
                    d="M.24,131.29C.16,93.38-4.02,49.14,26.37,20.89,59.2-9.63,130.87-6.83,158.33,30.11c17.71,23.82,16.9,47.79,17.92,75.87.04,1-.62,3.09.82,2.89L222.33,4.31h62.68v185.07h30.72v70.54h34.87v-70.54h29.89v191.71h-29.89v-68.05h-34.87v68.05h-88.01v-68.05h-114.57v-53.53c0-3.33,17.62-39.9,20.17-47.9.18-.56,1.52-3.02-.24-1.91-6.22,6.77-11.72,14.28-17.84,21.18-15.59,17.6-56.88,57.98-56.88,81.74v15.35h111.67l1.25,1.24v51.87H.24c.75-26.45-2.43-52.92,3.73-78.85,17.41-73.29,100.83-107.16,112.29-183.2,2.22-14.71,3.02-42.79-5.75-55.24-11.41-16.21-42.1-13.64-50.89,4.43-.78,1.61-3.75,10-3.75,11.19v50.62l-1.25,1.24H.24ZM227.72,259.1V118.01l-59.78,141.09h59.78Z" />
                <path
                    class="cls-10"
                    d="M350.56,259.78c-.13-.22-.08-.39.14-.52.7-1.47.35-3.04.36-4.55.03-20.45.1-40.89-.06-61.34-.03-3.5.93-4.55,4.37-4.37,8.13.42,16.29-.33,24.43.4.52,1.06.31,2.2.31,3.31,0,62.31,0,124.63,0,186.94,0,.7,0,1.4-.09,2.1-1.47,1.19-3.03.77-4.6.29.08-1.82.14-3.63.14-5.45,0-57.41,0-114.82,0-172.22,0-1.21.01-2.42,0-3.07.24.66-.02,1.92-.02,3.15.02,57.13.02,114.26,0,171.38,0,2.08.28,4.22-.65,6.21-7.83.73-15.66.55-23.49.1-.64-1.48-.32-3.04-.32-4.56-.02-19.74,0-39.48-.05-59.23,0-1.46.65-3.08-.58-4.4l.17.18c-1.15-1.2-2.61-.59-3.92-.6-9-.06-17.99-.02-26.99-.05-1.36,0-2.77.32-4.09-.36-.63-9.06-.18-18.13-.25-27.19-.06-8.24-.14-16.47.06-24.71,2.97-1.54,6.15-.5,9.21-.6,7.39-.23,14.79-.03,22.19-.12,1.23-.01,2.73.79,3.72-.72Z" />
                <path
                    class="cls-10"
                    d="M288.39,382.74h-.87c-1.65-.81-1.21-2.35-1.21-3.69-.02-20.14.01-40.28-.05-60.43,0-2.41.34-4.36,3.21-4.13,7.31.58,14.63.22,21.95.22,3.08,0,4,1.08,3.98,4.18-.12,19.86-.13,39.73,0,59.59.02,3.05-.63,4.09-3.85,4.05-7.72-.09-15.45-.48-23.17.21Z" />
                <path
                    class="cls-6"
                    d="M288.39,382.74c4.99-1.6,10.11-.32,15.16-.69,3.56-.26,8.11,1.47,10.45-.7,2.6-2.41.86-7.15.89-10.86.12-16.8-.03-33.6.12-50.41.03-3.33-.69-4.64-4.3-4.61-7.03.06-14.07.64-21.1-.36-2.04-.29-2.94,1.01-2.91,3.1.06,4.34.01,8.68.01,13.02,0,15.4,0,30.8,0,46.21,0,1.8-.28,3.66.82,5.3-.59.02-1.19.04-1.78.06-.02-21.42.05-42.85-.15-64.27-.04-3.85,1.2-4.67,4.75-4.53,7.18.29,14.38,0,21.57.12,2.52.04,3.37-.78,3.35-3.36-.09-16.1-.09-32.21,0-48.31.01-2.43-.87-3.14-3.16-3.11-7.61.1-15.21-.01-22.82.07-2.27.02-3.66-.39-3.64-3.15.15-22.26.22-44.51.31-66.77.58-.21,1.02-.04,1.32.5,1.01,2.1.74,4.37.74,6.59.03,18.14,0,36.27.02,54.41,0,5.88.24,6,6.06,6.13,6.74.16,13.5-.52,20.22.42.5.21.94.51,1.32.89.08.52.15,1.05.23,1.57.23.2.31.4.25.61-.06.22-.13.32-.2.32,0,17.39-.01,34.79-.02,52.18.22.21.28.41.19.6-.09.18-.18.26-.27.26-.02,21.68-.1,43.35.03,65.03.02,3.09-.67,4.07-3.84,3.95-7.86-.29-15.74-.17-23.61-.21Z" />
                <path
                    class="cls-4"
                    d="M379.68,382.01c0-64.15,0-128.31,0-192.46.31-.36.63-.37.96-.04.06,2.23.19,4.47.19,6.7.01,60.4,0,120.79,0,181.19,0,1.54-.12,3.07-.18,4.61-.32.32-.64.31-.96,0Z" />
                <path
                    class="cls-1"
                    d="M380.64,189.5c-.32.01-.64.03-.96.04-8.01-.03-16.03.13-24.03-.17-3.71-.14-4.26,1.42-4.24,4.66.12,20.14.08,40.28.05,60.42,0,1.61.62,3.38-.75,4.8-.03-22.66-.04-45.33-.11-67.99,0-1.82.18-2.75,2.39-2.72,8.7.13,17.41.05,26.12.06.67,0,1.41-.08,1.55.89Z" />
                <path
                    class="cls-9"
                    d="M315.62,258.42c-.25-.01-.51-.03-.76-.06-1.23-1.36-1.24-3.06-1.24-4.73-.04-20.06-.05-40.12,0-60.18,0-1.11.05-2.23.41-3.3.21-.53.51-.99.91-1.39.98.15.82.95.82,1.59-.04,22.69-.08,45.37-.13,68.06Z" />
                <path
                    class="cls-1"
                    d="M350.46,313.94c1.78,1.39.98,3.37.99,5.08.07,21,.06,41.99.08,62.99-.24.34-.49.35-.75.03-.05-21.17-.1-42.34-.17-63.51,0-1.53-.1-3.06-.15-4.59Z" />
                <path
                    class="cls-2"
                    d="M315.91,260.93c-.02-.31-.04-.62-.05-.94,11.57-.07,23.14-.14,34.71-.21-.79,1.73-2.36,1.15-3.64,1.15-10.34.03-20.68,0-31.01,0Z" />
                <path
                    class="cls-1"
                    d="M315.81,313.97c.03-.29.05-.57.08-.86,10.33,0,20.66-.03,31,0,1.3,0,2.82-.53,3.74,1.01-11.61-.05-23.21-.1-34.82-.14Z" />
                <path
                    class="cls-5"
                    d="M350.78,382.04c.25,0,.5-.01.75-.03,7.74,0,15.48,0,23.22,0,.27-.38.55-.39.83-.01,1.37,0,2.75,0,4.12,0,.32,0,.64,0,.96,0-.25,1.22-1.23.86-1.97.86-8.64.02-17.29.02-25.93,0-.71,0-1.71.4-1.97-.82Z" />
                <path
                    class="cls-7"
                    d="M314.93,188.77c0,.24-.01.49-.02.73-9.38,2.19-18.76,2.15-28.14.03-.28-.02-.55-.04-.83-.05-.05-.28-.1-.55-.15-.83,9.72.04,19.43.08,29.15.12Z" />
                <path
                    class="cls-3"
                    d="M375.57,382l-.41.02s-.41,0-.41,0c0-61.96,0-123.92,0-186.23,2.21,1.16,1.63,2.73,1.63,4,.03,59.25.02,118.51.03,177.76,0,1.55.02,3.09-.84,4.46Z" />
                <path
                    class="cls-10"
                    d="M286.77,189.53c9.38-.01,18.76-.02,28.14-.03-.02,22.96-.03,45.91-.05,68.87-8.16.02-16.32-.07-24.47.11-2.92.06-3.77-.93-3.76-3.85.13-21.7.11-43.4.14-65.1Z" />
            </g>
        </g>
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped>
    .cls-1 {
        fill: #342253;
    }

    .cls-2 {
        fill: #3c245d;
    }

    .cls-3 {
        fill: #46266a;
    }

    .cls-4 {
        fill: #39255f;
    }

    .cls-5 {
        fill: #43285b;
    }

    .cls-6 {
        fill: #40285b;
    }

    .cls-7 {
        fill: #362254;
    }

    .cls-8 {
        fill: #e33227;
    }

    .cls-9 {
        fill: #3f285a;
    }

    .cls-10 {
        fill: #482667;
    }
</style>
